import { AdjustedSection, ArrowLink, StyledSocialLinks } from './styles';
import { Col, Row } from 'react-styled-flexboxgrid';

import { KeyboardArrowRight } from '@styled-icons/material/KeyboardArrowRight';
import Image from '@/components/Image';
import LoadingIndicator from '@/components/LoadingIndicator';
import NotFoundPage from '@/components/404';
import PostContent from '@/components/Blog/PostContent';
import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import { useRouter } from 'next/router';

export const Profile = ({ profile, teamProfiles }) => {
  const router = useRouter();

  if (router.isFallback) {
    return (
      <AdjustedSection>
        <LoadingIndicator text="Loading" />
      </AdjustedSection>
    );
  }

  if (!profile) {
    return <NotFoundPage />;
  }

  const { bio, name, jobTitle, image, socials } = profile;
  return (
    <AdjustedSection>
      <ResponsiveGrid>
        <Row>
          <Col xs={12} sm={12} md={3} lg={3} mdOffset={1}>
            {image && <Image image={image.image} width={412} alt={name} />}
          </Col>
          <Col xs={12} sm={12} md={7} lg={7}>
            <header className="profile-header">
              <h1>{name}</h1>
              <h2>{jobTitle}</h2>
            </header>
            {socials?.showSocials && Array.isArray(socials.socials) && socials.socials.length > 0 && (
              <StyledSocialLinks socials={socials.socials} />
            )}
            <article>
              <PostContent content={bio} />
            </article>
            <footer>
              <ArrowLink href={teamProfiles?.bottomReadMoreUrl}>
                {teamProfiles?.bottomReadMoreText}
                <KeyboardArrowRight size={16} />
              </ArrowLink>
            </footer>
          </Col>
        </Row>
      </ResponsiveGrid>
    </AdjustedSection>
  );
};

export default Profile;
